// Read once, before analytics starts. Personal-link secrets live only in memory.
export const initialWorkspaceLink = (() => {
  if (
    typeof window === "undefined" ||
    window.location.pathname !== "/broker-workspace"
  )
    return "";
  const link =
    new URLSearchParams(window.location.hash.slice(1)).get("link") ?? "";
  window.history.replaceState(
    window.history.state,
    "",
    window.location.pathname + window.location.search,
  );
  return link;
})();
